import React from 'react'
import { graphql } from 'gatsby'
import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import Webinar from '@/components/Webinar'

const WebinarTemplate = ({ data }) => {
  const { strapiWebinar } = data
  const {
    title,
    downtitle,
    author,
    aside,
    webinarmeta,
    strapiId,
    banner,
    bannerhtml,
    sponsors,
    survey,
  } = strapiWebinar

  return (
    <Layout>
      <SEO title={`Ver Webinar: ${title}`} />
      {/* cannot pass data: is already defined, sorry code cops */}
      <Webinar
        video={data.strapiWebinar.data}
        author={author}
        title={title}
        downtitle={downtitle}
        aside={aside}
        webinarid={strapiId}
        webinarmeta={webinarmeta}
        banner={banner}
        bannerhtml={bannerhtml}
        sponsors={sponsors}
        survey={survey}
      />
    </Layout>
  )
}

export default WebinarTemplate

export const query = graphql`
  query webinarQuery($id: String!) {
    strapiWebinar(slug: { eq: $id }) {
      title
      downtitle
      slug
      strapiId
      bannerhtml
      banner {
        publicURL
      }
      data {
        description
        iframe
        title
      }
      webinarmeta {
        start
        end
        about
        id
        place
        private
        promovideo {
          iframe
          title
          description
        }
      }
      author {
        fullname
        title
        bio
        presenter
        avatar {
          childImageSharp {
            fixed(width: 210, height: 275) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
      aside {
        component
        text
        url
        block
        bullets {
          text
          url
        }
      }
      survey {
        id
        title
        questions {
          id
          select {
            text
            value
          }
          statement
          type
          required
        }
      }
      sponsors {
        block
        component
      }
    }
  }
`
